<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button fill="clear" size="large" (click)="close()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ translation.DomainCommon.Payment | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="logo-container">
    <img src="assets/old/images/payment-types/emkan.svg" />
  </div>
  <div class="add-voucher ion-margin-top">
    <ion-input [(ngModel)]="voucher" [disabled]="!!voucherAmount" placeholder="{{ translation.Payment.VoucherNumber | translate }}"></ion-input>
    <ion-input
      [(ngModel)]="applicationId"
      type="number"
      [disabled]="!!voucherAmount"
      placeholder="{{ translation.Payment.ApplicationId | translate }}"></ion-input>
    <ion-button (click)="getVoucherAmount()" [disabled]="!voucher || !applicationId || voucherAmount">
      {{ translation.Payment.AddVoucher | translate }}
    </ion-button>
  </div>
  <ion-row class="details ion-no-padding ion-margin-top" *ngIf="details">
    <ion-col class="price ion-no-padding" size="12" size-sm="5">
      <ion-item button detail="false" lines="none" (click)="copyPrice()">
        <ion-label>
          <p>{{ translation.Payment.PackagePriceIncludesVAT | translate }}</p>
          <h3>
            {{ details?.amountToPay }}
            <ion-icon src="assets/old/images/new-design/riyal-icon.svg" class="riyal-icon"></ion-icon>
          </h3>
        </ion-label>
        <ion-icon name="copy-outline" slot="end" color="primary"></ion-icon>
      </ion-item>
    </ion-col>
    <ion-col class="emkan-link" size="12" size-sm="6">
      <p>{{ translation.Payment.GetVoucherFromEmkanWebsite | translate }}</p>
      <a href="https://web.emkanfinance.com.sa/?vid=Mahara&&type=web" target="_blank">Emkan</a>
    </ion-col>
  </ion-row>
  <div class="voucher-details" *ngIf="voucherAmount">
    <p>{{ translation.Payment.VoucherAmount | translate }}</p>
    <h1>
      {{ voucherAmount }}
      <ion-icon src="assets/old/images/new-design/riyal-icon.svg" class="riyal-icon"></ion-icon>
    </h1>
  </div>
</ion-content>
<ion-footer class="ion-padding ion-no-border" id="emkan-footer">
  <ion-button expand="block" (click)="useVoucher()" *ngIf="voucherAmount && details">{{ translation.Common.Confirm | translate }}</ion-button>
</ion-footer>

<ion-popover #popover [isOpen]="showOTPPopover" (didDismiss)="showOTPPopover = false">
  <ng-template>
    <ion-content class="ion-padding" scroll-y="false">
      <ion-row>
        <ion-input class="ion-text-center" type="number" placeholder="{{ translation.Common.EnterOTP | translate }}" [(ngModel)]="otp"></ion-input>
      </ion-row>
    </ion-content>
    <ion-footer class="ion-padding">
      <ion-button [disabled]="!otp" expand="block" (click)="redeemVoucher(popover)">{{ translation.Common.Ok | translate }}</ion-button>
    </ion-footer>
  </ng-template>
</ion-popover>
